// src/components/forms/index.ts

// Base exports
export * from './base/types'
export * from './base/useEmailForm'
export { BaseEmailCaptureForm } from './base/BaseEmailCaptureForm'
export { FormErrorBoundary } from './base/ErrorBoundary'

// Variant exports
export { PopupEmailCapture } from './variants/popup/PopupEmailCapture'
export { CornerEmailCapture } from './variants/corner/CornerEmailCapture'
export { SplitEmailCapture } from './variants/split/SplitEmailCapture'
export { EmbeddedEmailCapture } from './variants/embedded/EmbeddedEmailCapture'
export { GatedContentEmailCapture } from './variants/gated/GatedContentEmailCapture'
export { HeroEmailCapture } from './variants/hero/HeroEmailCapture'

// Types
export type { PopupEmailCaptureProps } from './variants/popup/types'
export type { CornerEmailCaptureProps } from './variants/corner/types'
export type { SplitEmailCaptureProps } from './variants/split/types'
export type { EmbeddedEmailCaptureProps } from './variants/embedded/types'
export type { GatedContentEmailCaptureProps } from './variants/gated/types'
export type { HeroEmailCaptureProps } from './variants/hero/types' 